// /boards 게시판 유형(boardKind) 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).
// 옵션 값은 기존 검색 select(NORMAL/ALBUM/AGENDA/MEAL)와 100% 동일하게 유지한다.

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

export const boardKindMeta: Record<string, StatusMeta> = {
  NORMAL: { label: "이야기", color: "default" },
  ALBUM: { label: "포토앨범", color: "info" },
  AGENDA: { label: "알림장", color: "primary" },
  MEAL: { label: "식단표", color: "success" },
};

// 매핑에 없는 값도 안전하게 표시
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
